import React from 'react'
import Button from 'src/shared/components/Button'
import successIcon from 'src/assets/img/check.png'
import { FormHelperText, Typography } from '@material-ui/core'
import useStyles from './useStyles'

const ResetSuccess: React.FC = () => {
  const classes = useStyles()

  const goHome = () => {
    window.localStorage.clear()
    window.location.href = '/'
  }

  React.useEffect(() => {
    setTimeout(() => {
      goHome()
    }, 10000)
  }, [])

  return (
    <>
      <img className={classes.successIcon} src={successIcon} alt='' />
      <Typography variant='h5' className={classes.mainTitle}>
        重置密碼成功！
      </Typography>
      <FormHelperText className={classes.heplerText}>系統將在10秒後自動跳轉至登入頁，請前往登入頁重新登入</FormHelperText>
      <Button onClick={goHome} type='submit'>
        確定
      </Button>
    </>
  )
}

export default ResetSuccess
